import {Component, Input} from "@angular/core";
/**
 * Created by alex.y on 10/2/2017.
 */


@Component({
    selector: 'order-left-tab',
    templateUrl: 'leftTab.component.html',
    moduleId: module.id.toString()
})
export class LeftTabComponent {
    @Input()
    public title: string;

    @Input()
    public icon: string;

    @Input()
    public isPassed: boolean = false;

    @Input()
    public isCurrent: boolean = false;

}


// WEBPACK FOOTER //
// ./app/components/Managment/orderManagement/orderData/tabs/leftTab.component.ts